import styled from 'styled-components'

export const ButtonContainer = styled.button`

background-color: #FAFAFA;
border: 1px solid #FAFAFA;
border-radius: 20px;

height: 62px;
width: 30%;

margin: 20px;

&:hover{
    background-color: #FAFAFA40;
    cursor: pointer;
    color: #FAFAFA;
}


`